import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import {Suspense} from 'react'

import {useSlice} from '../../../../../hooks/useSlice'

import CleanupForm from './CleanupForm/CleanupForm.container'
import type {Props, RuleId} from './Rules.types'
import RulesList from './RulesList/RulesList.container'

type State = {
  showForm: boolean
  currentRuleId: RuleId | null
}
const initialState: State = {
  showForm: false,
  currentRuleId: null,
}
const reducers = {
  openRuleForm: (state: State, ruleId?: RuleId | null) => ({
    showForm: true,
    currentRuleId: ruleId?.length ? ruleId : state.currentRuleId,
  }),
  closeForm: (_: State, __: void) => initialState,
}

function Rules({
  holderNode,
  inheritedVisible,
  projectId,
  embedded = false,
  hideOwn = false,
  hideInherited = false,
  hideEnforced = false,
  readOnlyProjectsKey,
}: Props) {
  const [{showForm, currentRuleId}, {openRuleForm, closeForm}] = useSlice(reducers, initialState)
  return (
    <>
      {embedded ? null : <H1>{'Clean-up Rules'}</H1>}
      <Suspense>
        <RulesList
          projectId={projectId}
          onRuleOpenClick={openRuleForm}
          holderNode={holderNode}
          inheritedVisible={inheritedVisible}
          embedded={embedded}
          hideOwn={hideOwn}
          hideInherited={hideInherited}
          hideEnforced={hideEnforced}
          readOnlyProjectsKey={readOnlyProjectsKey}
        />
      </Suspense>
      {showForm && (
        <Suspense>
          <CleanupForm
            projectId={projectId}
            holderNode={holderNode}
            ruleId={currentRuleId}
            onCancel={closeForm}
            onComplete={closeForm}
            readOnlyProjectsKey={readOnlyProjectsKey}
          />
        </Suspense>
      )}
    </>
  )
}

export default Rules
